import React from 'react';
import './TrustedSection.css';

const TrustedSection = ({ onGetStarted, onLearnMore }) => {
const logos = [
  "https://logo.debounce.com/unwomen.org",
  "https://logo.debounce.com/pepperstone.com",
  "https://logo.debounce.com/nsf.gov",
  "https://logo.debounce.com/zooplus.com",
  "https://logo.debounce.com/admedia.com",
  "https://logo.debounce.com/next.co.uk",
  "https://logo.debounce.com/deloitte.com",
  "https://logo.debounce.com/honeywell.com",
  "https://logo.debounce.com/coxmediagroup.com",
  "https://logo.debounce.com/ey.com",
  "https://logo.debounce.com/benevity.com"
];


  const handleGetStarted = () => {
    if (typeof onGetStarted === 'function') onGetStarted();
  };

  const handleLearnMore = () => {
    if (typeof onLearnMore === 'function') onLearnMore();
  };

  return (
    <section className="trusted-section">
      {/* Top label */}
     

      {/* Figma-styled content */}
      <div className="trusted-content">
        <h1 className="trusted-title">
          Transform your business with{" "}
          <span className="highlightTrusted">AI-powered automation</span>
        </h1>

        <p className="trusted-subtext">
          XenaChat helps you answer faster, qualify better, and route requests to the right place, so your team focuses on high-value work.
        </p>

        <div className="trusted-ctas">
          <button className="handleButton" onClick={handleGetStarted}>
            Get Started
          </button>
          <button className="demobutton" onClick={handleLearnMore}>
            Learn how it works
          </button>
        </div>
      </div>
    </section>
  );
};

export default TrustedSection;
